import { useIntlayer } from 'react-intlayer';

interface IntroBlockProps {
  subtitle: string;
  description: string;
}

const IntroBlock = ({ subtitle, description }: IntroBlockProps) => {
  return (
    <div className="flex flex-col items-start w-full lg:w-[519px] group lg:cursor-pointer transition-colors">
      {/* Top decorative line */}
      <div className="h-2 w-full relative border-t border-white lg:border-graphite-700 lg:group-hover:border-white before:content-[''] before:absolute before:left-0 before:-top-px before:w-0.5 before:h-[calc(100%+2px)] before:bg-white lg:before:bg-graphite-700 lg:group-hover:before:bg-white after:content-[''] after:absolute after:right-0 after:-top-px after:w-0.5 after:h-[calc(100%+2px)] after:bg-white lg:after:bg-graphite-700 lg:group-hover:after:bg-white transition-colors" />

      {/* Content */}
      <div className="flex flex-col gap-5 px-4 py-10 lg:py-15 w-full">
        <p className="font-mono text-white text-sm tracking-wide uppercase leading-normal">
          {subtitle}
        </p>
        <p className="font-sans font-normal text-white lg:text-graphite-700 lg:group-hover:text-white text-base lg:text-xl leading-normal lg:leading-snug tracking-wide lg:tracking-normal transition-colors">
          {description}
        </p>
      </div>

      {/* Bottom decorative line (flipped) */}
      <div className="h-2 w-full relative border-t border-white lg:border-graphite-700 lg:group-hover:border-white before:content-[''] before:absolute before:left-0 before:-top-px before:w-0.5 before:h-[calc(100%+2px)] before:bg-white lg:before:bg-graphite-700 lg:group-hover:before:bg-white after:content-[''] after:absolute after:right-0 after:-top-px after:w-0.5 after:h-[calc(100%+2px)] after:bg-white lg:after:bg-graphite-700 lg:group-hover:after:bg-white scale-y-[-100%] transition-colors" />
    </div>
  );
};

export const IntroductionSection = () => {
  const { introduction } = useIntlayer('landing');

  return (
    <section className="bg-black px-4 lg:px-20 py-20 lg:py-30">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-[133px] items-start lg:items-center">
        <IntroBlock
          subtitle={introduction.whoWeAre.subtitle}
          description={introduction.whoWeAre.description}
        />
        <IntroBlock
          subtitle={introduction.whatWeDo.subtitle}
          description={introduction.whatWeDo.description}
        />
      </div>
    </section>
  );
};
